<template>
  <div
    :data-active="active"
    @drop.prevent="onDrop"
    @dragenter.prevent="setInactive"
    @dragover.prevent="setActive"
    @dragleave.prevent="setInactive"
  >
    <slot :dropZoneActive="active"></slot>
  </div>
</template>

<script>
const events = ["dragenter", "dragover", "dragleave", "drop"];
const preventsDefautls = e => e.preventDefault();
let inActiveTimeout = null;

export default {
  data() {
    return {
      active: false
    };
  },
  methods: {
    setActive() {
      this.active = true;
      clearTimeout(inActiveTimeout);
    },
    setInactive() {
      inActiveTimeout = setTimeout(() => {
        this.active = false;
      }, 100);
    },
    onDrop(e) {
      this.setInactive();
      this.$emit("files-dropped", [...e.dataTransfer.files]);
    }
  },
  mounted() {
    events.forEach(eventName => {
      document.body.addEventListener(eventName, preventsDefautls);
    });
  },
  destroyed() {
    events.forEach(eventName => {
      document.body.removeEventListener(eventName, preventsDefautls);
    });
  }
};
</script>
